import createVueApp from '@phoenix/createVueApp';

import { PhxsgSlide, PhxsgSlider } from '../Slider';

import PhxsgSelectionSlider from './phxsg-selection-slider.vue';

document.querySelectorAll('[data-component="phxsg-selection-slider"]').forEach((el) => {
  const app = createVueApp();
  app.component('PhxsgSlider', PhxsgSlider);
  app.component('PhxsgSlide', PhxsgSlide);
  app.component('PhxsgSelectionSlider', PhxsgSelectionSlider);
  app.mount(el);
});
